import React from "react";
import { get } from "lodash";
import { Route, Redirect } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import PropTypes from "prop-types";

import {
  ROUTE_DASHBOARD,
  ROUTE_LOGOUT,
  ROUTE_SIGNIN,
} from "../../globals/constants";
import { verifyToken } from "../../globals/utils/jwtUtils";

const ProtectedRoute = ({ grants, ...rest }) => {
  const { authData } = useSelector(
    (store) => ({
      authData: store.auth.data || {},
    }),
    shallowEqual
  );

  const token = get(authData, "idToken");
  const userType = get(authData, "user_type");

  const isVerified = token && verifyToken(token);

  const isUserPermitted =
    grants === "ALL" || (grants || []).some((type) => type === userType); // "ALL" or array of USER_TYPES. eg. ["ADMIN", "MAKER"]

  const isGranted = isVerified && isUserPermitted;

  return isGranted ? (
    <React.Suspense fallback={<></>}>
      <Route {...rest} />
    </React.Suspense>
  ) : isVerified ? (
    <Redirect to={ROUTE_DASHBOARD} />
  ) : token ? (
    <Redirect to={ROUTE_LOGOUT} />
  ) : (
    <Redirect to={ROUTE_SIGNIN} />
  );
};

export default ProtectedRoute;

ProtectedRoute.propTypes = {
  grants: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
};
